<template >
  <v-sheet
    style="background: white"
    class="fill-height d-flex justify-space-around"
  >
    <v-overlay opacity="0">
      <v-card style="max-width: 450px" color="white" elevation="0">
        <div class="text-right">
          <v-btn @click="close()" small icon>
            <v-icon color="#2A353D">mdi-close-circle</v-icon>
          </v-btn>
        </div>
        <v-img
          class="mt-0"
          src="../assets/flat.png"
          height="200"
          contain
          >
        </v-img>

        <v-form class="pa-12 pt-0" fluid ref="form" v-model="valid" lazy-validation name="form">
          <v-container>
            <v-text-field
              light
              color="#2A353D"
              prepend-inner-icon="mdi-lock"
              v-model="currentPassword"
              type="password"
              label="Current Password"
              outlined
              required
              :rules="currentPasswordRules"
            ></v-text-field>

            <v-text-field
              light
              color="#2A353D"
              prepend-inner-icon="mdi-lock"
              v-model="match"
              type="password"
              label="New Password"
              outlined
              required
              :rules="confirmPasswordRules"
            ></v-text-field>

            <v-text-field
              light
              color="#2A353D"
              prepend-inner-icon="mdi-lock"
              v-model="newPassword"
              type="password"
              label="Confirm Password"
              outlined
              required
              :rules="newPasswordRules"
            ></v-text-field>

            <v-btn v-if="!successful" :disabled="!valid" @click="updatePassword()" class="btn btn-primary btn-block" color="#2A353D">
              <span class="white--text font-weight-bold">Submit</span>
            </v-btn>
          </v-container>
        </v-form>

        <v-snackbar
          :value="showMessage()"
          multi-line
          color="#686868"
          top
          
        >
          {{message}}
        </v-snackbar>
      </v-card>
    </v-overlay>
  </v-sheet>
</template>

<script>
import userManagementService from '../services/userManagement.service';

export default {
  name: 'Change Password',

  data() {
    return {
      newPassword: '',
      currentPassword: '',
      match: '',
      message: '',
      valid: true,
      successful: false,

      currentPasswordRules: [
        v => !!v || 'current password is required',
      ],
      newPasswordRules: [
        v => !!v || 'confirm your new password',
        v => (!!v && v) === this.match || 'Passwords do not match',
      ],
      confirmPasswordRules: [
        v => !!v || 'new password required',
      ],
    };
  },

  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },

  methods: {
    async updatePassword () {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        var data = {
            Password: this.newPassword
          }
        userManagementService.changePassword(this.currentUser.SecurityUserID, data)
        .then(response => {
                this.message = response.data.message;
                this.successful = true;
                this.reset()
                // this.close()
            },
            error => {
                this.message =
                (error.response && error.response.data.message) ||
                error.message ||
                error.toString();
                this.successful = false;
            })
        .catch(e => {
            console.log(e)
        })
      }
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    close() {
      this.message = '';
      this.reset();
      this.successful = false;
      this.$root.$emit("closeChangePassword")
    },

    reset () {
      this.$refs.form.reset()
    },
  },
};
</script>

<style scoped>

#ChangePwd {
  background-color: white;
}

.text {
  color: #1C284E;
}

.v-btn {
  outline: none
}

</style>